import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-400">
      <Navbar data-id="element-401" />
      <main className="pt-32 pb-24" data-id="element-402">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-403">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-404">
            Cookie Policy
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-405">
            <p className="font-medium" data-id="element-406">Last updated: 14 December 2025</p>

            <p data-id="element-407">
              This Cookie Policy explains how KittyPot Ltd ("Company," "we,"
              "us," and "our") uses cookies and similar technologies to
              recognize you when you visit our website at
              https://www.kittypot.com ("Website"). It outlines what cookies
              are, why we use them, and your rights to control their usage.
            </p>

            <p data-id="element-408">
              In some cases, we may use cookies to collect personal information,
              or information that becomes personal when combined with other
              data.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-409">
              1. WHAT ARE COOKIES?
            </h2>
            <p data-id="element-410">
              Cookies are small data files placed on your computer or mobile
              device when you visit a website. These files are commonly used by
              website owners to make websites work or perform more efficiently
              and to provide reporting data.
            </p>
            <p data-id="element-411">
              Cookies set by the website owner (in this case, KittyPot Ltd) are
              referred to as "first-party cookies." Cookies set by parties other
              than the website owner are known as "third-party cookies."
              Third-party cookies allow the provision of third-party services on
              the website (e.g., advertising, interactive content, and
              analytics). These third parties may recognize your computer when
              you visit our website as well as when you visit other websites.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-412">
              2. WHY DO WE USE COOKIES?
            </h2>
            <p data-id="element-413">
              We use both first- and third-party cookies for various reasons.
              Some cookies are essential for technical reasons to make our
              website operate ("essential" or "strictly necessary" cookies).
              Other cookies help us track and target the interests of our users
              to improve their experience.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-414">
              3. HOW CAN I CONTROL COOKIES?
            </h2>
            <p data-id="element-415">
              You have the right to decide whether to accept or reject cookies.
              You can manage your cookie preferences via the Cookie Consent
              Manager. Essential cookies cannot be rejected as they are strictly
              necessary for the functionality of the website.
            </p>
            <p data-id="element-416">
              The Cookie Consent Manager is available through the notification
              banner and on our website. If you choose to reject cookies, you
              can still use our website, but some features may not be
              accessible. You can also configure your web browser to accept or
              reject cookies.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-417">
              Performance and Functionality Cookies
            </h3>
            <p data-id="element-418">
              These cookies enhance the performance and functionality of our
              website but are not essential.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-419">
              <li data-id="element-420">
                <strong data-id="element-421">Name:</strong> TS#
              </li>
              <li data-id="element-422">
                <strong data-id="element-423">Purpose:</strong> Enhances website security.
              </li>
              <li data-id="element-424">
                <strong data-id="element-425">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-426">
                <strong data-id="element-427">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-428">
                <strong data-id="element-429">Expires:</strong> Session
              </li>
            </ul>
            <ul className="list-disc pl-5 space-y-2 mt-4" data-id="element-430">
              <li data-id="element-431">
                <strong data-id="element-432">Name:</strong> XSRF-TOKEN
              </li>
              <li data-id="element-433">
                <strong data-id="element-434">Purpose:</strong> Prevents Cross-Site Request Forgery
                (CSRF).
              </li>
              <li data-id="element-435">
                <strong data-id="element-436">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-437">
                <strong data-id="element-438">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-439">
                <strong data-id="element-440">Expires:</strong> Session
              </li>
            </ul>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-441">
              Analytics and Customisation Cookies
            </h3>
            <p data-id="element-442">
              These cookies help us understand how our website is used and
              improve user experience.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-443">
              <li data-id="element-444">
                <strong data-id="element-445">Name:</strong> bolt-performance
              </li>
              <li data-id="element-446">
                <strong data-id="element-447">Purpose:</strong> Tracks performance metrics
              </li>
              <li data-id="element-448">
                <strong data-id="element-449">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-450">
                <strong data-id="element-451">Type:</strong> Pixel Tracker
              </li>
              <li data-id="element-452">
                <strong data-id="element-453">Expires:</strong> Session
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-454">
              4. HOW CAN I CONTROL COOKIES ON MY BROWSER?
            </h2>
            <p data-id="element-455">
              You can manage cookies through your browser settings. Please refer
              to your browser's help section for guidance.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-456">
              <li data-id="element-457">Chrome</li>
              <li data-id="element-458">Firefox</li>
              <li data-id="element-459">Safari</li>
              <li data-id="element-460">Edge</li>
              <li data-id="element-461">Opera</li>
            </ul>
            <p className="mt-4" data-id="element-462">
              You can also opt out of targeted advertising via:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-463">
              <li data-id="element-464">Digital Advertising Alliance</li>
              <li data-id="element-465">European Interactive Digital Advertising Alliance</li>
              <li data-id="element-466">Digital Advertising Alliance of Canada</li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-467">
              5. OTHER TRACKING TECHNOLOGIES
            </h2>
            <p data-id="element-468">
              We may use web beacons (tracking pixels) to measure website
              traffic and campaign effectiveness. These rely on cookies to
              function.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-469">
              6. FLASH COOKIES
            </h2>
            <p data-id="element-470">
              We may use Flash cookies for fraud prevention and service
              functionality. You can manage Flash cookies via Adobe Flash Player
              settings.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-471">
              7. TARGETED ADVERTISING
            </h2>
            <p data-id="element-472">
              Third-party advertisers may place cookies to deliver
              interest-based advertising. They do not collect personal data
              unless you provide it.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-473">
              8. POLICY UPDATES
            </h2>
            <p data-id="element-474">
              We may update this Cookie Policy periodically for legal,
              regulatory, or operational reasons.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-475">
              9. Unicorn Platform Cookies
            </h2>
            <p data-id="element-476">
              Our website is built using Unicorn Platform, which uses essential
              cookies required for core functionality.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-477">
              10. CONTACT US
            </h2>
            <p data-id="element-478">
              If you have any questions about this Cookie Policy, please contact
              us at support@kittypot.com or by post:
            </p>
            <address className="not-italic mt-4" data-id="element-479">
              KittyPot Ltd
              <br data-id="element-480" />
              Flat 2 Minavon
              <br data-id="element-481" />
              Cardiff
              <br data-id="element-482" />
              South Glamorgan
              <br data-id="element-483" />
              CF14 6BE
              <br data-id="element-484" />
              United Kingdom
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-485" />
    </div>;
}